import { render, staticRenderFns } from "./fund-info-phone.vue?vue&type=template&id=e6e17eb4&scoped=true&"
import script from "./fund-info-phone.vue?vue&type=script&lang=js&"
export * from "./fund-info-phone.vue?vue&type=script&lang=js&"
import style0 from "./fund-info-phone.vue?vue&type=style&index=0&id=e6e17eb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e17eb4",
  null
  
)

export default component.exports